import { useEffect, useState } from "react";
import { useMyProviderDataClient } from "../../../../context/ApiContext";

export interface EmployeeInfo {
  uhcEligibilityStatus?: string;
  state?: string;
  role?: string;
}

export const useMyProviderData = (username?: string) => {
  const client = useMyProviderDataClient();

  const [employee, setEmployee] = useState<EmployeeInfo>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!username) return;

    const load = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await client.get(
          "/EmployeeInformation/EmployeeInformation",
          { params: { username } }
        );

        setEmployee(response.data);
      } catch (err) {
        console.error(err);
        setError("Unable to load provider data.");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [username, client]);

  return { employee, loading, error };
};